import React from "react";
import { Reveal, SectionHeading } from "@/components/common/Reveal";
import { CAPITAL_SUPPORTS, EVALUATE, PRINCIPLES } from "@/data";
import { motion } from "framer-motion";
import { Check } from "lucide-react";

export function CapitalSupports() {
  return (
    <section className="relative py-24 md:py-32 border-t border-white/5" data-testid="capital-supports-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal><SectionHeading label="Use of Capital" title="What can the capital support?" className="max-w-3xl" /></Reveal>
        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
          {CAPITAL_SUPPORTS.map((c, i) => (
            <motion.div key={c} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: (i % 4) * 0.05 }} className="flex items-center gap-3 rounded-lg border border-white/5 bg-[#0C0C10] px-4 py-3.5 card-hover hover:border-white/15">
              <Check className="h-4 w-4 text-[#00D1FF] shrink-0" />
              <span className="text-sm text-zinc-400">{c}</span>
            </motion.div>
          ))}
        </div>
        <Reveal delay={0.1}><p className="mt-8 text-xs text-zinc-600 max-w-3xl leading-relaxed">The permitted use of funds and capital structure depend on the applicant's business, legal status, eligibility, documentation and the independent decision of the relevant capital provider.</p></Reveal>
      </div>
    </section>
  );
}

export function Evaluate() {
  return (
    <section className="relative py-24 md:py-32 border-t border-white/5" data-testid="evaluate-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal><SectionHeading label="Evaluation" title="What we evaluate." className="max-w-3xl" /></Reveal>
        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {EVALUATE.map((e, i) => (
            <Reveal key={e.n} delay={(i % 4) * 0.06}>
              <div className="card-hover h-full rounded-2xl border border-white/5 bg-[#0C0C10] p-6 hover:border-white/15" data-testid={`evaluate-${e.n}`}>
                <span className="font-mono text-sm text-[#0057FF]">{e.n}</span>
                <h3 className="font-head text-base font-medium mt-3 leading-snug">{e.title}</h3>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.1}><p className="mt-8 text-xs text-zinc-600 max-w-3xl leading-relaxed">Evaluation criteria may vary depending on the business stage, sector, legal structure and proposed capital route.</p></Reveal>
      </div>
    </section>
  );
}

export function Principles() {
  return (
    <section className="relative py-24 md:py-32 border-t border-white/5" data-testid="principles-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal><SectionHeading label="Our Principles" title="The FundAI principles." className="max-w-3xl" /></Reveal>
        <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {PRINCIPLES.map((p, i) => (
            <Reveal key={p.title} delay={(i % 3) * 0.08}>
              <div className="card-hover h-full rounded-2xl border border-white/5 bg-[#0C0C10] p-7 hover:border-white/15" data-testid={`principle-${i}`}>
                <h3 className="font-head text-lg font-medium">{p.title}</h3>
                <p className="mt-2 text-sm text-zinc-500 leading-relaxed">{p.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
